import React, { Suspense, Fragment, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Authenticated from "./Guard/Authenticated";
import Guest from "./Guard/Guest";
import BaseLayout from "./Layout/BaseLayout";
import SidebarLayout from "./Layout/SidebarLayout";

export function RenderRout() {
  return (
    <>
      <Router>
        <Suspense fallback={"....."}>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [
  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/login",
    element: lazy(() => import("./components/auth/Login")),
  },
{
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/forgetpassword",
    element: lazy(() => import("./components/auth/Forgetpassword")),
  },

   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/profile",
    element: lazy(() => import("./components/auth/Updateprofile")),
  },

   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/change-password",
    element: lazy(() => import("./components/auth/Changepassword")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/dashborad",
    element: lazy(() => import("./components/Pages/Dashboard/Index")),
  },

   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/users",
    element: lazy(() => import("./components/Pages/Users/Index")),
  },
    {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/faq",
    element: lazy(() => import("./components/Pages/Faq/Index")),
  },
    {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/types",
    element: lazy(() => import("./components/Pages/Type/Index")),
  },
      {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/review",
    element: lazy(() => import("./components/Pages/Review/Index")),
  },

   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/role",
    element: lazy(() => import("./components/Pages/Role/Index")),
  },

   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/navigation",
    element: lazy(() => import("./components/Pages/Navigation/Index")),
  },

   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/permission",
    element: lazy(() => import("./components/Pages/Permission/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/leads",
    element: lazy(() => import("./components/Pages/Leads/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/leads/:id",
    element: lazy(() => import("./components/Pages/Leads/Detiels")),
  },

 {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/contacts",
    element: lazy(() => import("./components/Pages/Contacts/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/contacts/:id",
    element: lazy(() => import("./components/Pages/Contacts/Detiels")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/sales",
    element: lazy(() => import("./components/Pages/Sales/Index")),
  },

 {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/campaign",
    element: lazy(() => import("./components/Pages/Campaign/Index")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/scheduling",
    element: lazy(() => import("./components/Pages/scheduling/Index")),
  },
    {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/accounts",
    element: lazy(() => import("./components/Pages/Accounts/Index")),
  },
     {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/reminder",
    element: lazy(() => import("./components/Pages/TaskReminder/Index")),
  },
     {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/management",
    element: lazy(() => import("./components/Pages/ProjectManagement/Index")),
  },
    {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/management/search",
    element: lazy(() => import("./components/Pages/ProjectManagement/Report")),
  },
  
   {
    layout: BaseLayout,
    exact: true,
    path: "/",
    element: lazy(() => import("./components/Pages/Home/Index")),
  },
   {
     guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/leads/opportunity/:id",
    element: lazy(() => import("./components/Pages/NewOpportunity/Index")),
  },
   {
     guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/deal-close/:id?",
    element: lazy(() => import("./components/Pages/Dealclose/Index")),
  },
   {
     guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/survey",
    element: lazy(() => import("./components/Pages/Survay/Index")),
  },
 {
   guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/survey/create",
    element: lazy(() => import("./components/Pages/Survay/Createsurvay")),
  },

   {
     guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/response",
    element: lazy(() => import("./components/Pages/Survay/Response")),
  },

   {
    layout: BaseLayout,
    exact: true,
    path: "/feedback/:id",
    element: lazy(() => import("./components/Pages/Survay/Feedback")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/response/reports",
    element: lazy(() => import("./components/Pages/Survay/SurveyReports")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/vendor",
    element: lazy(() => import("./components/Pages/vender-portal/Index")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/customer-portal",
    element: lazy(() => import("./components/Pages/customer-portal/Index")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/config",
    element: lazy(() => import("./components/Pages/admin-config/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/marketplace",
    element: lazy(() => import("./components/Pages/Marketplace/Index")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/subscription",
    element: lazy(() => import("./components/Pages/Subscription/Index")),
  },
   {
    guard: Authenticated,
    layout: BaseLayout,
    exact: true,
    path: "/payment-success",
    element: lazy(() => import("./components/Pages/Subscription/Successurl")),
  },
  {
    guard: Authenticated,
    layout: BaseLayout,
    exact: true,
    path: "/success",
    element: lazy(() => import("./components/Pages/Subscription/Cancelurl")),
  },
];
